import React from 'react';
import { Link } from 'react-router-dom';
import { FaRegClock, FaMapMarkerAlt, FaArrowRight, FaRegCalendarAlt } from 'react-icons/fa';
import './NewsAndEvents.css';
import Footer from '../Footer';

// Sermon & Announcement Images
// import serImg from '../../Assets/Ser3.jpg';
// import awakeImg from '../../Assets/awake.png';
import moneyMattersImg from '../../Assets/NewsAndEvents/MoneyMattersForum.png';

// Program Images
import roundtableImg from '../../Assets/NewsAndEvents/McRoundTable.png';
import sundayServiceImg from '../../Assets/NewsAndEvents/SundayService.png';
import tcgImg from '../../Assets/NewsAndEvents/TheChristGeneration.png';
import royalLadiesImg from '../../Assets/NewsAndEvents/RoyalLadiesFellowship.png';
import megaMcImg from '../../Assets/NewsAndEvents/MegaMc.png';
import kingsmenImg from '../../Assets/NewsAndEvents/KingsMenFellowship.png';

const NEWS = [
  /*
  {
    id: 'Follow-the-king',
    tag: 'New series',
    title: 'New Sermon Series: Follow The King',
    date: 'Sep 1st 2026',
    description:
      'A teaching series on the Call of God and how it shapes the way we live and serve in His Kingdom.',
    image: serImg,
    to: '/service-times',
    cta: 'Learn More',
  },
  {
    id: 'awake-campus',
    tag: 'Coming soon',
    title: 'Awake Campus Move',
    date: 'Dates to be announced',
    description:
      'A powerful campus gathering of worship, prayer and teaching is on the way. Follow us or reach out to be the first to know when dates are confirmed.',
    image: awakeImg,
    to: '/contact-us',
    cta: 'Get notified',
  },
  */
  {
    id: 'money-matters-forum',
    tag: 'Special Forum',
    title: 'The Money Matters Forum',
    date: 'Empowering Biblical Stewardship',
    description:
      'Join Dr. Alex Mutagubya, Rowena Turinawe, and guest financial leaders for practical, faith-rooted insights into budgeting, investment, and kingdom stewardship.',
    image: moneyMattersImg,
    to: '/financial',
    cta: 'Explore Money Matters',
  },
];

const WEEKLY_PROGRAMS = [
  {
    id: 'roundtable-discussions',
    schedule: 'Every Thursday',
    title: 'RoundTable Discussions',
    time: '5:30 PM - 7:00 PM',
    location: 'Missional Communities / All Campuses',
    description:
      'Engaging small group conversations diving deeper into the Sunday teaching, building genuine fellowship, and sharpening one another through the Word.',
    image: roundtableImg,
    to: '/weekly-round-table',
    cta: 'See Discussion Guide',
  },
  {
    id: 'sunday-services',
    schedule: 'Every Sunday',
    title: 'Sunday Services',
    time: '8:00 AM & 10:00 AM',
    location: 'All Campuses (Luzira, Kirinya, Iganga)',
    description:
      'Our vibrant weekly family gatherings for heartfelt worship, transformative biblical preaching, uplifting community, and dedicated kids church services.',
    image: sundayServiceImg,
    to: '/service-times',
    cta: 'Plan Your Visit',
  },
];

const MONTHLY_PROGRAMS = [
  {
    id: 'the-christ-generation',
    schedule: 'Last Saturday Monthly',
    title: 'The Christ Generation (TCG)',
    time: '4:00 PM onwards',
    location: 'The City Church, Luzira',
    description:
      'An energetic, youth-led atmosphere packed with dynamic contemporary worship, powerful life-changing messages, games, creative arts, and dinner.',
    image: tcgImg,
    to: '/tcg-page',
    cta: 'Explore Youth Ministry',
  },
  {
    id: 'royal-ladies-fellowship',
    schedule: 'Last Sunday Monthly',
    title: 'The Royal Ladies Fellowship',
    time: '10:00 AM',
    location: 'The City Church, Luzira',
    description:
      'Empowering women of all generations to walk in royal identity, spiritual leadership, purposeful sisterhood, family wisdom, and prayer.',
    image: royalLadiesImg,
    to: '/join-mc',
    cta: 'Connect With Women',
  },
  {
    id: 'mega-mc',
    schedule: 'Monthly Gathering',
    title: 'Mega MC (Mega Missional Community)',
    time: '5:00 PM',
    location: 'Main Church Auditorium',
    description:
      'All missional communities unite under one roof for an unforgettable evening of collective praise, inspiring testimonies, shared meals, and kingdom impact.',
    image: megaMcImg,
    to: '/join-mc',
    cta: 'Join a Missional Community',
  },
  {
    id: 'kingsmen-fellowship',
    schedule: 'Last Sunday Monthly',
    title: 'The Kings Men Fellowship',
    time: '4:00 PM',
    location: 'The City Church, Luzira',
    description:
      'Building strong, godly men through honest brotherhood, spiritual accountability, business mentorship, leadership equipping, and united prayer.',
    image: kingsmenImg,
    to: '/join-mc',
    cta: 'Join Kingsmen',
  },
];

function ProgramCard({ item }) {
  return (
    <li className="ev-card tcc-card tcc-card--hover">
      <div className="ev-card__media">
        <img src={item.image} alt={item.title} className="ev-card__img" loading="lazy" />
        <span className="ev-card__tag">{item.schedule}</span>
      </div>
      <div className="ev-card__body">
        <h3 className="ev-card__title">{item.title}</h3>
        <ul className="ev-card__facts">
          <li><FaRegClock aria-hidden="true" /> {item.time}</li>
          <li><FaMapMarkerAlt aria-hidden="true" /> {item.location}</li>
        </ul>
        <p className="ev-card__desc">{item.description}</p>
        <Link to={item.to} className="ev-card__cta">{item.cta} <FaArrowRight aria-hidden="true" /></Link>
      </div>
    </li>
  );
}

function NewsCard({ item }) {
  return (
    <li className="ev-card tcc-card tcc-card--hover">
      <div className="ev-card__media">
        <img src={item.image} alt={item.title} className="ev-card__img" loading="lazy" />
        <span className="ev-card__tag">{item.tag}</span>
      </div>
      <div className="ev-card__body">
        <p className="ev-card__date"><FaRegCalendarAlt aria-hidden="true" /> {item.date}</p>
        <h3 className="ev-card__title">{item.title}</h3>
        <p className="ev-card__desc">{item.description}</p>
        <Link to={item.to} className="ev-card__cta">{item.cta} <FaArrowRight aria-hidden="true" /></Link>
      </div>
    </li>
  );
}

function NewsAndEvents() {
  return (
    <>
      <header className="ev-hero">
        <div className="tcc-container ev-hero__inner">
          <p className="tcc-eyebrow ev-hero__eyebrow">What&rsquo;s on</p>
          <h1 className="ev-hero__title">News &amp; Events</h1>
          <p className="ev-hero__lead">
            Everything happening across The City Church family, from our weekly
            gatherings to our monthly fellowships and special forums. There&rsquo;s always a
            place for you.
          </p>
        </div>
      </header>

      {/* LATEST NEWS */}
      <section className="tcc-section ev-section" aria-labelledby="ev-news-h">
        <div className="tcc-container">
          <div className="ev-head">
            <p className="tcc-eyebrow">Latest News</p>
            <h2 className="tcc-h2" id="ev-news-h">Fresh From The Church</h2>
            <p className="tcc-lead">Special forums, announcements and what&rsquo;s coming up next.</p>
          </div>
          <ul className="ev-grid ev-grid--news">
            {NEWS.map((n) => <NewsCard key={n.id} item={n} />)}
          </ul>
        </div>
      </section>

      {/* WEEKLY PROGRAMS */}
      <section className="tcc-section tcc-section--surface2 ev-section" id="weekly-programs" aria-labelledby="ev-weekly-h">
        <div className="tcc-container">
          <div className="ev-head">
            <p className="tcc-eyebrow">Weekly Rhythm</p>
            <h2 className="tcc-h2" id="ev-weekly-h">Weekly Programs</h2>
            <p className="tcc-lead">Our regular weekly rhythm of deep scripture discussions, worship, and community.</p>
          </div>
          <ul className="ev-grid ev-grid--weekly">
            {WEEKLY_PROGRAMS.map((g) => <ProgramCard key={g.id} item={g} />)}
          </ul>
        </div>
      </section>

      {/* MONTHLY PROGRAMS */}
      <section className="tcc-section ev-section" id="monthly-programs" aria-labelledby="ev-monthly-h">
        <div className="tcc-container">
          <div className="ev-head">
            <p className="tcc-eyebrow">Monthly Fellowships</p>
            <h2 className="tcc-h2" id="ev-monthly-h">Monthly Programs &amp; Gatherings</h2>
            <p className="tcc-lead">Special monthly fellowships designed to empower youth, women, men, and our entire church community.</p>
          </div>
          <ul className="ev-grid ev-grid--monthly">
            {MONTHLY_PROGRAMS.map((g) => <ProgramCard key={g.id} item={g} />)}
          </ul>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default NewsAndEvents;
